import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

// Scroll ke atas setiap kali route berganti
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import ChatWidget from './components/ChatWidget';
import Home from './pages/Home';
import Sejarah from './pages/Sejarah';
import VisiMisi from './pages/VisiMisi';
import StrukturOrganisasi from './pages/StrukturOrganisasi';
import LogoKampus from './pages/LogoKampus';
import MarsStikes from './pages/MarsStikes';
import Humas from './pages/Humas';
import IT from './pages/IT';
import Baak from './pages/Baak';
import Bak from './pages/Bak';
import Bauk from './pages/Bauk';
import Kemahasiswaan from './pages/Kemahasiswaan';
import PrestasiMahasiswa from './pages/PrestasiMahasiswa';
import PrestasiMahasiswaDetail from './pages/PrestasiMahasiswaDetail';
import Kontak from './pages/Kontak';
// Batch 1 - Akademik
import ProgramStudi from './pages/ProgramStudi';
import ProgramStudiDetail from './pages/ProgramStudiDetail';
import DosenTendik from './pages/DosenTendik';
import DosenDetail from './pages/DosenDetail';
import TendikDetail from './pages/TendikDetail';
import KalenderAkademik from './pages/KalenderAkademik';
// Batch 2 - Info & Fasilitas
import Beasiswa from './pages/Beasiswa';
import TracerStudy from './pages/TracerStudy';
import PusatKarir from './pages/PusatKarir';
import SaranaPrasarana from './pages/SaranaPrasarana';
import SaranaPrasaranaDetail from './pages/SaranaPrasaranaDetail';
import UKM from './pages/UKM';
import UkmDetail from './pages/UkmDetail';
// Batch 3 - Berita & Konten
import Berita from './pages/Berita';
import BeritaDetail from './pages/BeritaDetail';
import Galeri from './pages/Galeri';
import Agenda from './pages/Agenda';
import Download from './pages/Download';
import DownloadDetail from './pages/DownloadDetail';
import SearchPage from './pages/SearchPage';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#F8F7FF] dark:bg-[#0A0A0F] transition-colors duration-300">
          <ScrollToTop />
          <Navbar />
          <Routes>
            {/* Core Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/sejarah" element={<Sejarah />} />
            <Route path="/visi-misi" element={<VisiMisi />} />
            <Route path="/struktur-organisasi" element={<StrukturOrganisasi />} />
            <Route path="/logo" element={<LogoKampus />} />
            <Route path="/mars-stikes" element={<MarsStikes />} />
            <Route path="/unit/humas" element={<Humas />} />
            <Route path="/humas" element={<Navigate replace to="/unit/humas" />} />
            <Route path="/unit/it" element={<IT />} />
            <Route path="/it" element={<Navigate replace to="/unit/it" />} />
            <Route path="/unit/pusat-karir" element={<PusatKarir />} />
            <Route path="/pusat-karir" element={<Navigate replace to="/unit/pusat-karir" />} />
            <Route path="/pusatkarir" element={<Navigate replace to="/unit/pusat-karir" />} />
            <Route path="/unit/baak" element={<Baak />} />
            <Route path="/baak" element={<Navigate replace to="/unit/baak" />} />
            <Route path="/unit/bak" element={<Bak />} />
            <Route path="/bak" element={<Navigate replace to="/unit/bak" />} />
            <Route path="/unit/bauk" element={<Bauk />} />
            <Route path="/bauk" element={<Navigate replace to="/unit/bauk" />} />
            <Route path="/unit/kemahasiswaan" element={<Kemahasiswaan />} />
            <Route path="/kemahasiswaan" element={<Navigate replace to="/unit/kemahasiswaan" />} />
            <Route path="/prestasi-mahasiswa" element={<PrestasiMahasiswa />} />
            <Route path="/prestasi-mahasiswa/:slug" element={<PrestasiMahasiswaDetail />} />
            <Route path="/kontak" element={<Kontak />} />
            {/* Batch 1 — Akademik */}
            <Route path="/program-studi" element={<ProgramStudi />} />
            <Route path="/program-studi/:slug" element={<ProgramStudiDetail />} />
            <Route path="/dosen-tendik" element={<DosenTendik />} />
            <Route path="/dosen/:slug" element={<DosenDetail />} />
            <Route path="/tendik/:slug" element={<TendikDetail />} />
            <Route path="/kalender" element={<KalenderAkademik />} />
            <Route path="/kalender/:slug" element={<KalenderAkademik />} />
            {/* Batch 2 — Info & Fasilitas */}
            <Route path="/beasiswa" element={<Beasiswa />} />
            <Route path="/tracer-study" element={<TracerStudy />} />
            <Route path="/sarana-prasarana" element={<SaranaPrasarana />} />
            <Route path="/sarana-prasarana/kategori/:categorySlug" element={<SaranaPrasarana />} />
            <Route path="/sarana-prasarana/:slug" element={<SaranaPrasaranaDetail />} />
            <Route path="/ukm" element={<UKM />} />
            <Route path="/ukm/kategori/:categorySlug" element={<UKM />} />
            <Route path="/ukm/:slug" element={<UkmDetail />} />
            {/* Batch 3 — Berita & Konten */}
            <Route path="/berita" element={<Berita />} />
            <Route path="/berita/:slug" element={<BeritaDetail />} />
            <Route path="/galeri" element={<Galeri />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/download" element={<Download />} />
            <Route path="/download/:slug" element={<DownloadDetail />} />
            <Route path="/search" element={<SearchPage />} />
          </Routes>
          <Footer />
          <FloatingButtons />
          <ChatWidget />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
